import { create } from 'zustand'
import type { PublicConfig } from '@/types'
import { fetchConfig } from '@/lib/api'

interface ConfigState {
  config: PublicConfig | null
  loading: boolean
  error: string | null
  load: () => Promise<void>
}

export const useConfigStore = create<ConfigState>((set, get) => ({
  config: null,
  loading: false,
  error: null,

  load: async () => {
    if (get().config || get().loading) return
    set({ loading: true, error: null })
    try {
      const config = await fetchConfig()
      set({ config, loading: false })
    } catch (err) {
      set({ error: (err as Error).message, loading: false })
    }
  },
}))
